import { CompareKeyMetricsTableOneKey } from '@op/pages/Overview/CompareKeyMetrics/constants';
import {
  defaultDealwithTableColumns,
  getBaseList,
  getKeyColumns,
} from '@op/components/TableCommonHook/hooks/useCompareKeyMetricsColumns';
import { getGameColorOrName } from '@op/pages/Overview/CompareKeyMetrics/utils';

export default function (key: CompareKeyMetricsTableOneKey) {
  return function (params: any) {
    let {
      by_type = undefined,
      tab_type = undefined,
      baseColumn = [],
      gameData = {},
    } = params;

    const getGameInfo = getGameColorOrName(gameData);
    let oneKey = key,
      twoKey = tab_type,
      threeKey = by_type;

    if (key === 'Steam') {
      twoKey = by_type;
      threeKey = undefined;
    }

    const originColumns = defaultDealwithTableColumns(
      getKeyColumns(oneKey, twoKey, threeKey),
      getBaseList(baseColumn, by_type, tab_type),
    );

    return [
      {
        header: 'Game',
        render: 'edition_unified_id',
        renderHelper: [
          (item: any, key: string) => {
            return getGameInfo(item[key]);
          },
        ],
      },
      ...originColumns.map((item) => ({ ...item, render: item.key })),
    ];
  };
}
